export default __webpack_public_path__ + "static/media/blackjack_banner.c254686a.jpg";